import React, { Suspense, useEffect, useRef, useState } from 'react';
import Head from 'next/head';
import st from './index.module.scss';
import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import VideoStyles from '../../../components/video-production/VideoStyles';
import LazyLoad, { forceCheck, lazyload } from 'react-lazyload';
import VoiceArtistsSlider from '../../../components/video-production/VoiceArtistsSlider';
import VideoReviewsSlider from '../../../components/sliders/VideoReviewsSlider';
import Faq from '../../../components/Faq';
import ProcessSlider from '../../../components/sliders/ProcessSlider';
import dynamic from 'next/dynamic';
import { Lottie } from '@crello/react-lottie';
import typesLottie from '../../../public/images/types.json';
import casesLottie from '../../../public/images/cases.json';
import industriesLottie from '../../../public/images/industries.json';
const Offer = dynamic(() => import('../../../components/Offer'));

lazyload({
  width: '100%',
});

const ExplainerVideos = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);
  const [step, setStep] = useState(1);
  const [key, setkey] = useState(0);
  const [modalKey, setModalKey] = useState(0);
  const [showOfferModal, setShowOfferModal] = useState(false);
  const [positions, setPositions] = useState([
    {
      name: 'Whiteboard Explainer Video',
      price: ['$1200', '€1100', '£1000', 'A$1900', 'S$1600', 'CA$1600', '₽120000', 'NZ$2000', 'AED 4400', 'QAR 4370', 'SR 4500', 'KWD 370'],
    },
    {
      name: '2D Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: '3D Explainer Video',
      price: ['$2700', '€2600', '£2200', 'A$4300', 'S$3700', 'CA$3700', '₽269000', 'NZ$4600', 'AED 9920', 'QAR 9830', 'SR 10.130', 'KWD 830'],
    },
    {
      name: 'Live Action Explainer Video',
      price: ['$3500', '€3300', '£2900', 'A$5500', 'S$4800', 'CA$4800', '₽350000', 'NZ$5900', 'AED 12.850', 'QAR 12.740', 'SR 13.140', 'KWD 1080'],
    },
    {
      name: 'Drawn Explainer Video',
      price: [
        '$13500',
        '€12900',
        '£11100',
        'A$21300',
        'S$18500',
        'CA$18500',
        '₽1350000',
        'NZ$22900',
        'AED 49.580',
        'QAR 49.150',
        'SR 50.630',
        'KWD 4150',
      ],
    },
    {
      name: 'Motion Graphics Explainer Video',
      price: ['$1200', '€1100', '£1000', 'A$1900', 'S$1600', 'CA$1600', '₽120000', 'NZ$2000', 'AED 4400', 'QAR 4370', 'SR 4500', 'KWD 370'],
    },
    {
      name: 'Isometric Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: '30sec Explainer Video',
      price: ['$1100', '€1000', '£900', 'A$1700', 'S$1500', 'CA$1500', '₽110000', 'NZ$1900', 'AED 4040', 'QAR 4010', 'SR 4130', 'KWD 340'],
    },
    {
      name: 'Product Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'Website Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'Corporate Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'APP Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'Healthcare/Medical Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'Educational Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'SAAS Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'Startup Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'Crypto Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'Financial Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'Real Estate Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
    {
      name: 'B2B Explainer Video',
      price: ['$1300', '€1200', '£1100', 'A$2100', 'S$1800', 'CA$1800', '₽130000', 'NZ$2200', 'AED 4770', 'QAR 4740', 'SR 4880', 'KWD 400'],
    },
  ]);

  const [currentStep, setCurrentStep] = useState(0);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      // document.getElementById("pricing-form").reset();
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  useEffect(() => {
    const stickyBar = document.getElementById('stickyBar');
    const stickyBarOffset = stickyBar ? stickyBar.offsetTop : 0;
    const triggers = document.querySelectorAll('#stickyBar > div');
    const sections = [document.getElementById('videoTypes'), document.getElementById('videoUseCases'), document.getElementById('videosByIndustries')];

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop >= stickyBarOffset) {
        stickyBar.classList.add('sticky');
      } else {
        stickyBar.classList.remove('sticky');
      }

      sections.forEach((section, index) => {
        if (scrollTop >= section.offsetTop - 200 && scrollTop <= section.offsetHeight + section.offsetTop) {
          setCurrentStep(index + 1);
        }
      });
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        const targetHref = trigger.getAttribute('targetHref');
        const section = document.querySelector(targetHref);

        section.scrollIntoView({ behavior: 'smooth' });
      });
    });

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    formTotalPrice();
    forceCheck();
  }, [props.currency]);
  const formTotalPrice = () => {
    const currency = props.currency.toString().toLowerCase();

    if (currency == 'amd') {
      setkey(0);
    }

    if (currency == 'eur') {
      setkey(1);
    }

    if (currency == 'gbp') {
      setkey(2);
    }

    if (currency == 'aud') {
      setkey(3);
    }

    if (currency == 'sgd') {
      setkey(4);
    }

    if (currency == 'cad') {
      setkey(5);
    }

    if (currency == 'rub') {
      setkey(6);
    }

    if (currency == 'nzd') {
      setkey(7);
    }
  };
  const showOfferModalFunction = (title, key) => {
    document.getElementById('offer-form').reset();
    setShowOfferModal(true);
    setModalKey(key);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  };
  const hideOfferModalFuntion = () => {
    setShowOfferModal(false);
    setModalKey(0);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  return (
    <>
      <Head>
        <title>Trusted & Engaging Custom Explainer Videos | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/explainer-videos" />
        <meta
          name="description"
          content="Engage your audience with custom explainer videos that simplify complex ideas. Discover Prodigi tailored video production services to elevate your brand."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/explainer-videos" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Trusted & Engaging Custom Explainer Videos | Prodigi" />
        <meta
          property="og:description"
          content="Engage your audience with custom explainer videos that simplify complex ideas. Discover Prodigi tailored video production services to elevate your brand."
        />
        <meta property="og:image" content="https://weprodigi.com/images/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "Product",
              "name": "Explainer Video Production Types",
              "image": "https://admin.weprodigi.com/uploads/images/explainer-videos/heading-image.svg",
              "description": "Our Explainer Video Production Package offers a variety of services tailored for creating engaging and informative explainer videos, suitable for businesses of all sizes.",
              "brand": {
                "@type": "Brand",
                "name": "WeProdigi"
              },
              "offers": {
                "@type": "Offer",
                "url": "https://weprodigi.com/video-production/explainer-videos",
                "price": "1000",
                "priceCurrency": "USD",
                "seller": {
                  "@type": "Organization",
                  "name": "WeProdigi"
                }
              },
              "additionalProperty": [
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType1",
                  "name": "WHITEBOARD EXPLAINER VIDEO",
                  "value": "A whiteboard explainer video is hand-drawn visuals to clarify concepts and convey impactful messages."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType2",
                  "name": "2D EXPLAINER VIDEO",
                  "value": "A 2D explainer video utilizes two-dimensional graphics to visually simplify and convey complicated topics, products, or services."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType3",
                  "name": "3D EXPLAINER VIDEO",
                  "value": "3D explainer videos are one of the best solutions if you have a physical product that needs to be revealed in detail or when you want to bring a 2D animation to the next level."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType4",
                  "name": "LIVE ACTION EXPLAINER VIDEO",
                  "value": "Live-explainer video brings your product into life showcasing how it functions in the real world."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType5",
                  "name": "DRAWN EXPLAINER VIDEO",
                  "value": "This type of explainers, known for its vast creative possibilities, primarily serves to deliver entertainment and educational content efficiently."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType6",
                  "name": "MOTION GRAPHICS EXPLAINER VIDEO",
                  "value": "A motion graphic explainer video is a mix of graphics, text and infographics that conveys messages and move in a 2-dimensional environment, meaning they are measured by their height and width."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType7",
                  "name": "ISOMETRIC EXPLAINER VIDEO",
                  "value": "Isometric explainer videos are a type of animation created on a 2D surface with a 3D effect."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType8",
                  "name": "30SEC EXPLAINER VIDEO",
                  "value": "A 30-second explainer video is an engaging clip that uses animation or live-action to simplify a complex idea or concept."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType9",
                  "name": "PRODUCT EXPLAINER VIDEO",
                  "value": "As the name implies these types of videos are about “the product”- be it a tangible or intangible one."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType10",
                  "name": "WEBSITE EXPLAINER VIDEO",
                  "value": "A website explainer video is an invaluable asset for businesses, simplifying complex concepts and engaging website visitors effectively."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType11",
                  "name": "CORPORATE EXPLAINER VIDEO",
                  "value": "A corporate explainer video serves as a versatile resource used for a variety of purposes."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType12",
                  "name": "APP EXPLAINER VIDEO",
                  "value": "APP explainer videos are one of the best ways to give a guided and detailed representation of your software, its new features, and how they look and work."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType13",
                  "name": "HEALTHCARE EXPLAINER VIDEO",
            "value": "While your healthcare technology or product may be life-changing, it is more important to help your consumers understand and trust what you provide."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType14",
                  "name": "EDUCATIONAL EXPLAINER VIDEOS",
                  "value": "Educational video production services is the best way to describe your company."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType15",
                  "name": "SAAS EXPLAINER VIDEO",
                  "value": "This is where videos come to the rescue. Video is a godsend for SaaS marketers as presenting a product with a 2-minute video is much easier than with a 1000-word guideline."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType16",
                  "name": "STARTUP EXPLAINER VIDEO",
                  "value": "3D explainer videos are one of the best solutions if you have a physical product that needs to be revealed in detail or when you want to bring a 2D animation to the next level."
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType17",
                  "name": "CRYPTO EXPLAINER VIDEO",
                  "value": "A crypto explainer video production is an essential tool for cryptocurrency and blockchain marketing. "
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType18",
                  "name": "FINANCIAL EXPLAINER VIDEO",
                  "value": "The financial sector, laden with specialized terminology like ROI, diversification, hedging, and liquidity, often becomes perplexing for many. "
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType19",
                  "name": "REAL ESTATE EXPLAINER VIDEO",
                  "value": "One of the best ways is to have an eye-catching explainer video answering her questions about the buying process, showcasing testimonials from previous buyers who've found their dream home with your company and etc. "
                },
                {
                  "@type": "PropertyValue",
                  "propertyID": "VideoType20",
                  "name": "B2B EXPLAINER VIDEO",
                  "value": "Often businesses struggle to communicate the depth and efficiency of their services to potential business partners. This is where B2B explainer videos come to the rescue. "
                }
              ],
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "5",
                "reviewCount": "1"
              },
              "review": [
                {
                  "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "John Miles" 
              },
                  "datePublished": "2023-12-01",
                  "reviewBody": "The explainer video produced for our company was outstanding. Professional service and great results.Thx",
                  "reviewRating": {
                    "@type": "Rating",
                    "bestRating": "5",
                    "ratingValue": "5",
                    "worstRating": "1"
                  }
                }
              ]
              }
        `,
          }}
        />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "How long does it take to produce an explainer video?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "On average, our usual production cycle requires from three to five weeks. But if you have a set deadline, we always try to offer custom solutions without any extra fees."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How is payment processed?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The client should pay for the finished work, rather than with a deposit. Thats why we chose a milestone payment option, as we believe that it's a more trustworthy approach in our work."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How involved do I need to be in the production process?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "It is totally up to you. We have created a production process where everything is created to save you time. At the same time, you can be integrated into every process of our production and hold discussions and brainstorm with us."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How do you handle complex topics in explainer videos?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "From Engineering to healthcare, our scriptwriters are skilled in any field and ready to apply their knowledge in a new field and in a new direction to get the desired result. Before working on the script and the original video, our specialists get acquainted with the details of the field and the project during the research and discovery stages. In addition, you have the option to change the script until we get the result you want free of any charges."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How much does an explainer video cost?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Explainer video costs vary from $400 to $10,000. While prices vary widely, we recommend a budget of $1,500 to $4,500 for a balance of quality and affordability, ensuring you receive a professional product without overpaying."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I get my explainer video in a different language or multiple languages?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely! We have native scriptwriters in German, French, Spanish, and Russian. For other languages, we collaborate with native translators to ensure your video communicates effectively in any desired language."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What is an animated explainer video?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "An explainer video is a short, engaging video usually used in marketing and sales. It breaks down a complex idea or product for easier understanding."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How to make an explainer video?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Making an explainer video involves storytelling, animation, and sound design. While software can help, a dedicated explainer video production company ensures professional quality, tailored storytelling, and effective engagement. It's the best choice for a polished and impactful video."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What makes a good explainer video?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "A good explainer video is clear, concise, and engaging. It communicates complex ideas using compelling visuals, a well-paced script, and a professional voiceover. Additionally, it resonates with its target audience and aligns with brand identity. Opting for a production company guarantees these qualities."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I get a discount for ordering multiple explainer videos?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Certainly! In the case of multiple videos, we provide an exclusive rate and other benefits to our clients to make the project mutually beneficial. The videos can be created either simultaneously or gradually. Moreover, we provide a free demo version which will reassure you made the right decision by choosing us."
                  }
                }
              ]
            }`,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src={'https://weprodigi.com/uploads/images/explainer-videos/HEADER-VIDEO.mp4'} type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Custom Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>
      <div className="bg-gray-light">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <h2 className={'max-w-650 leading-normalHeading uppercase text-24 md:text-48 text-black font-bold pb-24'}>
              What is an explainer video production?
            </h2>
            <Engagement title="Video">
              Hello and welcome to our explainer video production services page! Here you will find what is explainer video production, styles of
              explainer videos, where they can be used effectively, and industry uses of explainer videos. With this information at hand, we hope
              you'll find the perfect explainer video that much your current needs perfectly.Getting into video marketing is all about creating killer
              explainer videos. Think of these videos as your cool teacher, breaking down how your solutions tackle real-life problems and building a
              solid bond with your audience.One of the most important elements of a successful explainer video is to partner with{' '}
              <a className="text-purple" href="https://weprodigi.com/video-production">
                full service video production
              </a>{' '}
              company as it creates a perfect harmony between script, voiceover, and visuals that represent your corporate identity. Oh, and about the
              video length? The length of your video is the second crucial element. Although the optimal duration is approximately 1.5 minutes, a
              duration of one to two minutes guarantees that your audience perceives your main point without experiencing any overload of
              information.The cost of producing an animated explainer video might vary significantly. However, we're proud to combine quality with
              cost-effectiveness, delivering top-tier explainers ranging from $1,800 to $5,800.Cheers to making your mark!
            </Engagement>
          </div>
        </div>
      </div>
      <div id="stickyBar" className="hidden md:grid grid-cols-3 gap-x-2 h-48 text-white" style={{ paddingTop: 0, paddingBottom: 0 }}>
        <div
          targetHref="#videoTypes"
          className={`cursor-pointer transition-colors bg-opacity-80 px-5 leading-none flex items-center justify-center uppercase text-center ${
            currentStep === 1 ? 'font-bold bg-green-badge' : 'bg-purple-transparent hover:text-green'
          }`}
        >
          Explainer Video Types
        </div>
        <div
          targetHref="#videoUseCases"
          className={`cursor-pointer transition-colors bg-opacity-80 px-5 leading-none flex items-center justify-center uppercase text-center ${
            currentStep === 2 ? 'font-bold bg-green-badge' : 'bg-purple-transparent hover:text-green'
          }`}
        >
          Explainer Video Use Cases
        </div>
        <div
          targetHref="#videosByIndustries"
          className={`cursor-pointer transition-colors bg-opacity-80 px-5 leading-none flex items-center justify-center uppercase text-center ${
            currentStep === 3 ? 'font-bold bg-green-badge' : 'bg-purple-transparent hover:text-green'
          }`}
        >
          Explainer Videos by Industries
        </div>
      </div>
      <div id="videoTypes" className="bg-white pt-48 md:py-64">
        <div className="container">
          <div className="flex flex-wrap md:flex-nowrap">
            <div className="flex flex-col gap-6">
              <h2 className={'text-green text-24 md:text-36 font-bold uppercase'}>TYPES OF EXPLAINER VIDEO PRODUCTION</h2>
              <p className="max-w-756">
                In this section you will discover explainer video production types and can choose the option that fits your brand identity and current
                need. Explore further and choose the perfect fit for your brand!
              </p>
            </div>
            <LazyLoad className="mx-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
              <Lottie
                config={{
                  animationData: typesLottie,
                  loop: true,
                  autoPlay: true,
                }}
                playingState="playing"
              />
            </LazyLoad>
          </div>
        </div>
        <div className="container px-0 md:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3px md:gap-30 mt-24 md:mt-48">
            <VideoStyles
              config={{
                title: 'WHITEBOARD EXPLAINER VIDEO',
                description: (
                  <p>
                    A whiteboard explainer video is hand-drawn visuals to clarify concepts and convey impactful messages. Education, healthcare and IT
                    are three of the largest consuming industries of whiteboard animation video production services because it allows them to quickly
                    and efficiently explain what their services do and how they can help their customers without having to give a long presentation or
                    skip important details. These animations are a great way to spice up your website, social media, or email newsletters. With the
                    right concept, it unlocks significant marketing potential, captivating audiences and driving action. The effectiveness of
                    whiteboard animation depends on whether it is dynamic, creative, and eye-catching. That's why at{' '}
                    <a className="text-purple" href="https://weprodigi.com/about-us">
                      ProDigi
                    </a>{' '}
                    we create whiteboard videos in a fully custom version, where our illustrators hand-draw everything from characters to simple
                    items, without the use of Doodly or other similar tools, which make the video look cheap and bore the viewer.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/XS8M2Zp3NPQ?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[0].price[key],
                action: showOfferModalFunction,
                key: 0,
                btnLink: 'https://weprodigi.com/video-production/whiteboard-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: '2D Explainer Video',
                description: (
                  <p>
                    A 2D explainer video utilizes two-dimensional graphics to visually simplify and convey complicated topics, products, or services.
                    This animation style is not only visually engaging but also cost-effective. Unlike 3D, 2D videos require fewer resources, making
                    them a budget-friendly option for businesses. The major benefit of 2D animation is being highly customizable. Additionally, when
                    considering delivery time, 2D explainer videos typically require 2-3 weeks, ensuring faster turnarounds for businesses.
                    Considering above mentioned points they are bestsellers in the market. From small businesses to large multinational companies, 2D
                    explainer videos will effectively target your audience and send the message you want them to hear. Our specialists are well-versed
                    in the most up-to-date programs for creating the most impressive 2D explainer videos. And what differentiates us from others is
                    that you will avoid the additional charges for revisions at each stage of explainer video production.
                  </p>
                ),
                videoFrame: `https://www.youtube.com/embed/AAAnoo0NYpc?si=2N9DJrKmbnJsfitW&amp;controls=0`,
                price: positions[1].price[key],
                action: showOfferModalFunction,
                key: 1,
                btnLink: 'https://weprodigi.com/video-production/2d-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: '3D Explainer Video',
                description: (
                  <p>
                    3D explainer videos are one of the best solutions if you have a physical product that needs to be revealed in detail or when you
                    want to bring a 2D animation to the next level. They're not just about aesthetics; they simplify complex topics and demonstrate
                    product functionality effectively.Though 3D explainer video may seem like a premium investment, it's a game-changer. Even more
                    simplistic 3D animation videos can be very entertaining and effective at relaying information about your business.In ProDigi we
                    have assembled a group of a-list 3D specialists with an assortment of skills in modeling, texturing, lighting, rendering, and
                    animating. We transform your blueprint & drawing into a stunning 3D animation video that you can use in advertisements or for
                    offline presentations, whether it's a Solidworks / CAD design or just a sketch.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/UHCqHK84izk?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[2].price[key],
                action: showOfferModalFunction,
                key: 2,
                btnLink: 'https://weprodigi.com/video-production/3d-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'Live Action Explainer Video',
                description: (
                  <p>
                    Live-explainer video brings your product into life showcasing how it functions in the real world. Real actors, locations, and
                    props are used in live-action explainer videos to engage viewers.
                    <br />
                    They are perfect solutions for displaying physical products, showing real-world scenarios, and forming authentic ties. These
                    videos, in comparison to cartoons or 3D animations, include real people and real-world surroundings.They're superb for product or
                    service explanations. In the world of video marketing, live-action explainers are determined for their authentic presentation.
                    According to Videonomics “Consumers are 64% to 85% more likely to purchase after watching a real product video online”. Live
                    action explainers provide an immediate sense of realism, which can bridge the gap between businesses and their target audience.
                    This type of video can often resonate deeper, especially when viewers see relatable situations or people they can identify with.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/s2ujd3vp6FE?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[3].price[key],
                action: showOfferModalFunction,
                key: 3,
                btnLink: 'https://weprodigi.com/video-production/live-action-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'Drawn Explainer Video',
                description: (
                  <p>
                    Drawn explainers (also known as frame-by-frame animation)the most beloved form of animation, as all well-known cartoons like
                    Mickey Mouse or King Lion are created with this type of animation. This type of explainers, known for its vast creative
                    possibilities, primarily serves to deliver entertainment and educational content efficiently. But businesses also can benefit from
                    it for innovative product and service promotion.
                    <br />
                    Video animation created by this technique consists of hundreds or even thousands of frames and artists create each frame
                    separately. For each second in the cartoon, the animator has to create 24 frames. The more detailed the drawing is made, the
                    smoother will be the movement of the characters.
                    <br />
                    With our experts' mastery of hand-drawn animation, every frame becomes an art, elevating your message with creativity and
                    precision.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/jYWkmDOkZI4?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[4].price[key],
                action: showOfferModalFunction,
                key: 4,
                btnLink: 'https://weprodigi.com/video-production/frame-by-frame-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'Motion Graphics Explainer Video',
                description: (
                  <p>
                    A motion graphic explainer video is a mix of graphics, text and infographics that conveys messages and move in a 2-dimensional
                    environment, meaning they are measured by their height and width. Typically running for 60-90 seconds, these videos find utility
                    across websites, social media platforms, and other marketing channels.The utilization of motion graphic explainer videos is on the
                    rise among businesses aiming to enhance engagement, increase conversions, and bolster brand recognition.The power of motion
                    graphic videos is the ability to break down complex or complicated topics into practical visual parts. Furthermore, their bright
                    and dynamic nature may elicit emotions or emphasize certain themes, making them an effective tool in storytelling and brand
                    narrative.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/HuzCGZ15ZBE?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[5].price[key],
                action: showOfferModalFunction,
                key: 5,
                extraClass: 'mt-36',
                btnLink: 'https://weprodigi.com/video-production/motion-graphics-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'Isometric Explainer Video',
                description: (
                  <p>
                    Isometric explainer videos are a type of animation created on a 2D surface with a 3D effect. It is a trendy style applicable
                    across various industries and purposes, but those who prefer these videos the most are SAAS companies. Because of their vibrant
                    shapes, styles, colors and dynamic movements make this format engaging, informing, and persuading. This videos deliver your
                    messages quickly and clearly without wasting the viewers' time.To improve communication with your business community and showcase
                    your products and business you can use an isometric explainer video and get a competitive advantage in your digital presence.And
                    of course we ensure that your isometric video aligns perfectly with your goals and ideas, delivering a compelling and visually
                    stunning end product.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/GGcN1lJNvj0?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[6].price[key],
                action: showOfferModalFunction,
                key: 6,
                btnLink: 'https://weprodigi.com/video-production/isometric-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: '30sec Explainer Video',
                description: (
                  <p>
                    A 30-second explainer video is an engaging clip that uses animation or live-action to simplify a complex idea or concept. It aims
                    to grab attention, deliver a clear message, and leave a lasting impact.
                    <br />
                    With just half a minute of runtime, you can captivate your audience and convey your key points effortlessly. These versatile
                    videos are perfect for product launches, brand introductions, or conveying complex concepts in a flash.
                    <br />
                    The biggest challenge in creating an effective 30-second explainer video is crafting a simple yet compelling script. Our
                    professional scriptwriters will utilize their experience to condense your key and vital information into a concise video.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/FKFO59ndlVc?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[7].price[key],
                action: showOfferModalFunction,
                key: 7,
                btnLink: 'https://weprodigi.com/video-production/thirty-second-explainer-video',
              }}
            />
          </div>
        </div>
      </div>
      <div id="videoUseCases" className="bg-white md:bg-gray-light pt-48 md:py-64">
        <div className="container">
          <div className="flex flex-wrap md:flex-nowrap">
            <div className="flex flex-col gap-6">
              <div className="flex flex-row items-start gap-10 text-green text-24 md:text-36 font-bold uppercase">
                <h2>EXPLAINER VIDEO USE CASES</h2>
              </div>
              <p className="max-w-756">
                Find out where explainer videos can be used and what results can be expected from different applications. This is useful whether you
                have a product or app to promote or want to display the video on your website.
              </p>
            </div>
            <LazyLoad className="mx-auto mt-24 md:mt-0 max-w-350 w-full md:w-auto" height={200} once>
              <Lottie
                config={{
                  animationData: casesLottie,
                  loop: true,
                  autoPlay: true,
                }}
                playingState="playing"
              />
            </LazyLoad>
          </div>
        </div>
        <div className="container px-0 md:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3px md:gap-30 mt-24">
            <VideoStyles
              config={{
                title: 'PRODUCT EXPLAINER VIDEO',
                description: (
                  <p>
                    As the name implies these types of videos are about “the product”- be it a tangible or intangible one. A product explainer video
                    is a visually engaging presentation of your product's features and functionalities. By turning complex ideas into easy-to-digest
                    visuals, these videos make understanding products straightforward and quick. Typically lasting between 1 to 3 minutes, they focus
                    on the core aspects of a product, often starting with a problem statement, followed by the solution the product offers, and
                    concluding with its key benefits. You kind of create a visual where the customers imagine what it would be like to use your
                    product. This is a great marketing tool, which can break down complex ideas and information about your product quickly and
                    concisely.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/wx2P-qYv7HU?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[8].price[key],
                action: showOfferModalFunction,
                key: 8,
                btnLink: 'https://weprodigi.com/video-production/product-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'WEBSITE EXPLAINER VIDEO',
                description: (
                  <p>
                    A website explainer video is an invaluable asset for businesses, simplifying complex concepts and engaging website visitors
                    effectively. It enhances user engagement, boosting conversion rates across diverse industries.Including an explainer video on your
                    website is crucial. According to Statista, websites with an explainer video get a 45% or higher increase in conversion rates.
                    These statistics highlight the video's capacity to drive user action, from purchases to inquiries.Creating an effective website
                    explainer video can be challenging, requiring a deep business understanding and compelling storytelling. We are not only experts
                    in video production, but we also have a core understanding of website design and are well-versed in the main principles of
                    creating high-quality website explainer videos to improve website engagement. They take a personalized approach, ensuring videos
                    convey your messages effectively, converting website visitors into customers.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/VQU3kV_Motc?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[9].price[key],
                action: showOfferModalFunction,
                key: 9,
                btnLink: 'https://weprodigi.com/video-production/website-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'CORPORATE EXPLAINER VIDEO',
                description: (
                  <p>
                    A corporate explainer video serves as a versatile resource used for a variety of purposes. It can introduce a company, its
                    products, services, or processes, engage an employee, train a staff member, simplify a complex idea, and enhance brand visibility.
                    <br />
                    Businesses have diverse corporate needs, including effective communication, employee training, and simplifying intricate concepts.
                    Corporate explainer videos address these needs by conveying information in a concise, engaging, and easily understandable manner,
                    ensuring clarity and alignment across teams.
                    <br />
                    Research indicates that visual information is processed faster by the human brain than textual content, making corporate explainer
                    videos an effective method for businesses to convey essential messages, ensuring they're not just heard, but truly understood.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/XS8M2Zp3NPQ?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[10].price[key],
                action: showOfferModalFunction,
                key: 10,
                key: 8,
                btnLink: 'https://weprodigi.com/video-production/corporate-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'APP EXPLAINER VIDEO',
                description: (
                  <p>
                    APP explainer videos are one of the best ways to give a guided and detailed representation of your software, its new features, and
                    how they look and work. They provide a detailed description of a product solution, enhancing user understanding and driving
                    downloads and app usage. These videos come in various styles, such as animation for creative visuals or demo screencast.
                    Incorporating demo screencasts is crucial, allowing users to see the app in action and promoting confidence. At ProDigi, we're
                    proud of our wide experience in creating APP explainer videos. We've worked with a variety of industries including software,
                    healthcare, fashion, and others. Our videos are designed to engage users, enhance app adoption, and support businesses in
                    navigating the digital landscape effectively.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/6s-t27GvpHo?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[11].price[key],
                action: showOfferModalFunction,
                key: 11,
                btnLink: 'https://weprodigi.com/video-production/app-explainer-video',
              }}
            />
          </div>
        </div>
      </div>
      <div id="videosByIndustries" className="bg-white pt-48 md:py-64">
        <div className="container">
          <div className="flex flex-wrap md:flex-nowrap">
            <div className="flex flex-col gap-6">
              <div className="flex flex-row items-start gap-10 text-green text-24 md:text-36 font-bold uppercase">
                <h2>Explainer Videos By Industries</h2>
              </div>
              <p className="max-w-756">
                Discover how you can use explainer videos for your specific industry, view other similar videos in your industry and get inspired to
                create your own.
              </p>
            </div>
            <LazyLoad className="mx-auto mt-24 md:mt-0 max-w-250 md:max-w-320 w-full md:w-auto" height={200} once>
              <Lottie
                config={{
                  animationData: industriesLottie,
                  loop: true,
                  autoPlay: true,
                }}
                playingState="playing"
              />
            </LazyLoad>
          </div>
        </div>
        <div className="container px-0 md:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3px md:gap-30 mt-24 md:mt-48">
            <VideoStyles
              config={{
                title: 'HEALTHCARE EXPLAINER VIDEO',
                description: (
                  <p>
                    While your healthcare technology or product may be life-changing, it is more important to help your consumers understand and trust
                    what you provide. This is where healthcare explainer videos may assist in educating and empowering your audience to make
                    decisions. Whether it's detailing a surgical procedure, clarifying the workings of a medical device, or elucidating a specific
                    medical concept, these videos prioritize clarity and accuracy. An experienced video production agency with relevant expertise can
                    create impactful healthcare explainer videos explaining complicated processes and medical terminology in simple animations,
                    educating and helping patients understand the treatment.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/nHJ6-7WIIQI?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[12].price[key],
                action: showOfferModalFunction,
                key: 12,
                btnLink: 'https://weprodigi.com/video-production/healthcare-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'EDUCATIONAL EXPLAINER VIDEOS',
                description: (
                  <p>
                    If you are searching for a method to educate your audience in a non-traditional way, an educational explainer video is a powerful
                    solution in modern learning environments. Unlike traditional teaching methods, which are often overloaded with texts and lectures,
                    explainer videos present information in a dynamic, visually stunning format. One of the pain points faced by educators and
                    learners is the challenge of catching attention and facilitating complicated topics. To overcome this challenge educational
                    explainer videos must have a thoroughly written script and custom-created visuals. Our approach merges custom visuals with clear,
                    concise scripting to deliver content that not only draws in learners but also aids in better understanding and retention.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/kIh1QFcwHfM?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[13].price[key],
                action: showOfferModalFunction,
                key: 13,
                btnLink: 'https://weprodigi.com/video-production/educational-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'SAAS  EXPLAINER VIDEO',
                description: (
                  <p>
                    Since SaaS is non-material, it can be hard to explain in a nutshell. This is where videos come to the rescue. Video is a godsend
                    for SaaS marketers as presenting a product with a 2-minute video is much easier than with a 1000-word guideline. It can be used on
                    your website, product or service pages, lobby display, social media, email, trade shows, sales meetings, etc. These videos serve
                    several marketing purposes, from introducing new software features to driving user engagement and conversions. 2D and isometric
                    animations are the preferred styles in the SAAS industry. ProDigi is the leading agency in explainer video production, with
                    extensive experience working with software companies. Our specialists understand the industry complications, allowing us to create
                    fully customized SAAS explainer videos that align with your marketing objectives.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/KxPiwOO-RpY?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[14].price[key],
                action: showOfferModalFunction,
                key: 14,
                btnLink: 'https://weprodigi.com/video-production/saas-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'STARTUP EXPLAINER VIDEO',
                description: (
                  <p>
                    As an owner of a new business or the founder of a startup, your biggest initial challenge is to get people to understand exactly
                    what you offer. Videos for startups and new businesses are a great way to break this gap between your knowledge of your product
                    and the lack of it that your future customers have. A startup explainer video helps show your product/service features, present
                    your ideas to investors, increase customer engagement, and help bridge the gap between innovation and understanding. For startups
                    seeking a way to engage and inform their audiences startup explainer video is the right choice. Our creative team develops the
                    best strategy to depict your new ideas through an explainer video.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/xazKv4yYawc?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[15].price[key],
                action: showOfferModalFunction,
                key: 15,
                btnLink: 'https://weprodigi.com/video-production/startup-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'CRYPTO EXPLAINER VIDEO',
                description: (
                  <p>
                    A crypto explainer video production is an essential tool for cryptocurrency and blockchain marketing. From introducing new
                    cryptocurrencies and ICOs to explaining complex blockchain concepts, it simplifies intricate topics for a broad audience. In the
                    current market, 2D animations and motion graphics are the preferred styles. Keeping videos between 90 seconds to 2 minutes ensures
                    optimal viewer engagement. High-quality visuals, clear narration, and accurate information are industry benchmarks. At ProDigi,
                    our edge is our specialists' profound cryptocurrency expertise. Combining this knowledge with our professionalism, we craft
                    top-tier crypto explainer videos tailored to your dynamic marketing needs.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/N0q6WBkVrb8?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[16].price[key],
                action: showOfferModalFunction,
                key: 16,
                btnLink: 'https://weprodigi.com/video-production/crypto-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'FINANCIAL EXPLAINER VIDEO',
                description: (
                  <p>
                    Navigating the intricate realms of asset management, derivatives, equity markets, and financial planning can be daunting. The
                    financial sector, laden with specialized terminology like ROI, diversification, hedging, and liquidity, often becomes perplexing
                    for many. A major pain point is the potential risk of misinterpretation or even costly mistakes due to this complexity. This is
                    where financial explainer video production shines. By converting complex terms like compound interest, credit default swaps, and
                    quantitative easing into engaging visuals and clear narratives, these videos bring clarity. Whether it's breaking down fiscal
                    policy impacts or illustrating bond yield curves, financial explainer videos are instrumental in making intricate financial
                    concepts accessible, and ensuring sound financial choices.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/_ZwMTr2JzZ0?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[17].price[key],
                action: showOfferModalFunction,
                key: 17,
                extraClass: 'mt-36',
                btnText: 'Learn More',
                btnLink: 'https://weprodigi.com/video-production/financial-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'REAL ESTATE EXPLAINER VIDEO',
                description: (
                  <p>
                    Imagine this: Jessica, a potential home buyer, is scrolling through numerous real estate listings online. Now answer the question.
                    How are you going to attract her attention? One of the best ways is to have an eye-catching explainer video answering her
                    questions about the buying process, showcasing testimonials from previous buyers who've found their dream home with your company
                    and etc. To create a compelling real estate explainer video the company should understand the unique journey of each buyer, seller
                    and real-estate professional Prodigi doesn't just create explainers but also crafts engaging stories that will connect with your
                    audience.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/PElD4j_raE8?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[18].price[key],
                action: showOfferModalFunction,
                key: 18,
                btnText: 'Learn More',
                btnLink: 'https://weprodigi.com/video-production/real-estate-explainer-video',
              }}
            />
            <VideoStyles
              config={{
                title: 'B2B EXPLAINER VIDEO',
                description: (
                  <p>
                    Often businesses struggle to communicate the depth and efficiency of their services to potential business partners. This is where
                    B2B explainer videos come to the rescue. The success of a B2B explainer video depends on a clear, understandable script. A
                    perfectly written script helps to understand the value proposition of the business quickly, making an initial connection with a
                    business more productive and focused. You can use these videos from Linkedin and corporate website to email marketing campaigns.
                    We have deep expertise in the B2B sector as we provide not only video production services but also{' '}
                    <a className="text-purple" href="https://weprodigi.com/social-media-marketing">
                      SMM services
                    </a>{' '}
                    to our B2B partners. Our goal is to help B2B businesses save more time and achieve their business goals. Our B2B explainer videos
                    are carefully customized to align with each brand identity, ethos and specific messaging requirements.
                  </p>
                ),
                videoFrame: 'https://www.youtube.com/embed/zx5wetEYxVw?si=2N9DJrKmbnJsfitW&amp;controls=0',
                price: positions[19].price[key],
                action: showOfferModalFunction,
                key: 19,
                btnLink: 'https://weprodigi.com/video-production/B2B-explainer-video',
              }}
            />
          </div>
        </div>
      </div>
      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-48 h-auto'}>
          <div className="container">
            <h2 className={'text-purple font-black text-24 md:text-32 uppercase'}>choose your explainer video's voice</h2>
            <p className={'hidden md:block pt-10'}>
              As a cutting-edge video production agency we offer our clients a wide range of video animation voiceovers. You can choose the best
              voiceover that matches your brand identity from our extensive library and get high-quality videos that speak in a voice that emphasizes
              your brand's ideas, goals, and style.
            </p>
            <div className="flex mt-15">
              <div className={'voiceover w-full'}>
                <VoiceArtistsSlider />
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="bg-white py-48">
          <div className="container">
            <p className="text-purple text-24 md:text-32 uppercase font-black mb-24 leading-none">explainer video testimonials from our clients</p>
            <VideoReviewsSlider
              reviews={[
                {
                  video: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/SharonFinal1.mp4',
                  thumbnail: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/sharon.png',
                  logo: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/Lane1.png',
                  position: 'Chief Development Officer |',
                  custommerName: 'Sharon B. Cunninghis',
                  case: 'https://weprodigi.com/main/case/64',
                  flag: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/us.png',
                },
                {
                  video: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/ZackFinal1.mp4',
                  thumbnail: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/zach.png',
                  logo: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/Vuit-logo2.png',
                  position: 'Founder |',
                  custommerName: 'Zach Marinello',
                  case: 'https://www.youtube.com/watch?v=xazKv4yYawc&list=PLHJMKI8WX4RYaTdB13PaRsm_MsgnLZmuG&index=5',
                  flag: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/uk.png',
                },
                {
                  video: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/DianaFinal.mp4',
                  thumbnail: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/diana.png',
                  logo: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/Logo-Animation01.png',
                  position: 'Head of Marketing Department |',
                  custommerName: 'Diana Gaeta',
                  case: 'https://weprodigi.com/main/case/86',
                  flag: 'https://admin.weprodigi.com/uploads/files/shares/thumbs/us.png',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className={'h-500 md:h-310 overflow-hidden ' + st.bgPricing}>
          <div className="flex flex-col md:flex-row container md:items-end justify-between h-full">
            <div className={'w-full mt-48 md:mt-0 md:text-center text-white h-full flex flex-col md:items-center md:justify-center'}>
              <h3 className={'text-24 md:text-36 font-bold uppercase leading-none mb-24'}>explainer video pricing</h3>
              <p className={'text-16 md:text-24'}>Answer five questions and get to know the price!</p>
              <button
                onClick={showPricingModal}
                className={
                  'relative flex max-w-180 ml-auto md:ml-0 items-center justify-center text-center uppercase z-10 mt-48 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 py-5 bg-green-badge hover:bg-green-hover hover:text-white transition-all transition-400 cursor-pointer'
                }
              >
                Start Now
              </button>
            </div>
            <img
              className={'-mt-15 -ml-15 transform -scale-x-1 md:scale-x-100 max-w-270'}
              src="https://weprodigi.com/uploads/images/explainer-videos/girlIcon.png"
              alt="alt image"
            />
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">EXPLAINER VIDEO ANIMATION PROCESS</h2>
            <ProcessSlider />
          </div>
        </div>
      </LazyLoad>
      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'How long does it take to produce an explainer video?',
                    answer:
                      'On average, our usual production cycle requires from three to five weeks. But if you have a set deadline, we always try to offer custom solutions without any extra fees.',
                  },
                  {
                    title: 'How involved do I need to be in the production process?',
                    answer:
                      'It is totally up to you. We have created a production process where everything is created to save you time. At the same time, you can be integrated into every process of our production and hold discussions and brainstorm with us.',
                  },
                  {
                    title: 'How much does an explainer video cost?',
                    answer:
                      'Explainer video costs vary from $400 to $10,000. While prices vary widely, we recommend a budget of $1,500 to $4,500 for a balance of quality and affordability, ensuring you receive a professional product without overpaying.',
                  },
                  {
                    title: 'What is an animated explainer video?',
                    answer:
                      'An explainer video is a short, engaging video usually used in marketing and sales. It breaks down a complex idea or product for easier understanding.',
                  },
                  {
                    title: 'How to make an explainer video?',
                    answer:
                      "Making an explainer video involves storytelling, animation, and sound design. While software can help, a dedicated explainer video production company ensures professional quality, tailored storytelling, and effective engagement. It's the best choice for a polished and impactful video.",
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How is payment processed?',
                    answer: (
                      <p>
                        The client should pay for the finished work, rather than with a deposit. That’s why we chose a milestone payment option, as we
                        believe that it's a more trustworthy approach in our work. You can have all the needed information about our payment terms{' '}
                        <a className="text-purple" href="https://weprodigi.com/payment-terms">
                          here
                        </a>{' '}
                        .
                      </p>
                    ),
                  },
                  {
                    title: 'How do you handle complex topics in explainer videos?',
                    answer:
                      'From Engineering to healthcare, our scriptwriters are skilled in any field and ready to apply their knowledge in a new field and in a new direction to get the desired result. Before working on the script and the original video, our specialists get acquainted with the details of the field and the project during the research and discovery stages. In addition, you have the option to change the script until we get the result you want free of any charges.',
                  },
                  {
                    title: 'Can I get my explainer video in a different language or multiple languages?',
                    answer:
                      'Absolutely! We have native scriptwriters in German, French, Spanish, and Russian. For other languages, we collaborate with native translators to ensure your video communicates effectively in any desired language.',
                  },
                  {
                    title: 'What makes a good explainer video?',
                    answer:
                      'A good explainer video is clear, concise, and engaging. It communicates complex ideas using compelling visuals, a well-paced script, and a professional voiceover. Additionally, it resonates with its target audience and aligns with brand identity. Opting for a production company guarantees these qualities.',
                  },
                  {
                    title: 'Can I get a discount for ordering multiple explainer videos?',
                    answer:
                      'Certainly! In the case of multiple videos, we provide an exclusive rate and other benefits to our clients to make the project mutually beneficial. The videos can be created either simultaneously or gradually. Moreover, we provide a free demo version which will reassure you made the right decision by choosing us.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>
      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={step} />
      <Offer
        country={props.country}
        show={showOfferModal}
        hide={hideOfferModalFuntion}
        title={positions[modalKey].name}
        offerPrice={positions[modalKey].price[key]}
        offerDuration={''}
      />
    </>
  );
};

export default ExplainerVideos;
